import { useStaticQuery, graphql } from "gatsby"
import { DetermineSlugLocale } from "../utils/locale"

function useSiteSettings(locale) {
  const results = useStaticQuery(
    graphql`
      query GetSettings {
        allStoryblokEntry(
          filter: {field_component: {eq:"site_settings"}}
        ) {
          edges {
            node {
              id
              name
              full_slug
              field_component
              uuid
              content
            }
          }
        }
      }
    `
  )
  const settings = {}
  results.allStoryblokEntry.edges.forEach((edge)=>{
    let content = JSON.parse(edge.node.content)
    let settingLocale = DetermineSlugLocale(edge.node.full_slug)
    settings[settingLocale] = content
  })
  return settings[locale] || {}
}

export default useSiteSettings